import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    //状态数据
    state: {
        isShow: false,
        answer: [],
        allowBack:true,
        userInfo:{},//用户中心
        breadcrumb:[],
        true_answer:'',
        question_list:'',
        is_click:null,
        animation:'animate__animated animate__fadeInUp',//图片动画
    },
    //同步方法
    mutations: {
        PushAnswer(state,data){
            state.answer = data
        },
        updateAppSetting(state,data){
            state.allowBack = data
        },
        updateUser(state,data){
            state.userInfo = data
        },
        updateBreadcrumb(state,data){
            state.breadcrumb = data;
        },
        set_true_answer(state,data){
            state.true_answer = data
        },
        set_question_list(state,data){
            state.question_list = data
        },
        set_is_click(state,data){
            state.is_click = data
        },
    },
    //计算属性
    getters: {
        getBreadcrumb:(state,data)=>{
            return state.breadcrumb;
        }
    },
    //异步方法
    actions:{
    },
    modules:{}
});
